import axios from 'axios'
import globalUtilityService, { GlobalUtility } from '../../service/global-utility.service'
import { USER_ACCOUNTS } from '@/service/constants.service'
import GlobalUtilityService from '../../service/global-utility.service'

const initState = () => {
  return {
    accounts: [],
    account: {},
    newAccount: {
      fName: null,
      mName: null,
      lName: null,
      userTypeId: 2, // default staff for all new created account
      posId: null,
      username: null
    },
    objUserTypes: [],
    objPositions: []
  }
}

const state = {
  ...initState()
}

const mutations = {
  set_accounts (state, payload) {
    state.accounts = payload
  },

  set_account (state, payload) {
    console.log('set_account:mutation', payload)
    state.account = payload
  },

  create_account (state, payload) {
    state.newAccount = {
      fName: null,
      mName: null,
      lName: null,
      userTypeId: 2, // default staff for all new created account
      posId: null,
      username: null
    }
    state.accounts.push(payload)
  },

  update_account (state, payload) {
    console.log('update_account:mutation', payload)
    const account = state.accounts.find((val, index) => {
      return val.id === payload.id
    })
    Object.assign(account, payload)
  },

  // TODO
  delete_account (state, payload) {
    console.log('delete_account:mutation', payload)
    const index = state.accounts.findIndex((val, index) => {
      return val.id === payload
    })
    state.accounts.splice(index, 1)
  },

  reset_state_account (state) {
    console.log('reset_account:mutation')
    Object.assign(state, initState())
  },

  set_obj_user_types (state, payload) {
    console.log('set_obj_user_types:mutation')
    state.objUserTypes = payload
  },

  reset_obj_user_types (state) {
    state.objUserTypes = []
  },

  set_obj_positions (state, payload) {
    state.objPositions = payload
  },

  reset_obj_positions (state) {
    state.objPositions = []
  },

  reset_obj_account (state) {
    state.account = {}
  }

}

const actions = {
  /**
   * @author get all accounts
   */
  async set_accounts ({ commit }, params) {
    //    let url = `${CREW}?page=${params.page}`;
    const URL = `${USER_ACCOUNTS}?page=${params.page}`
    return await axios.get(URL, { params }).then((r) => {
      console.log('Fetching all accounts', r.data.data)
      commit('set_accounts', r.data.accounts.data)
      commit('set_account_pagination', r.data.accounts)
      commit('set_obj_user_types', r.data.objUserTypes)
      commit('set_obj_positions', r.data.objPositions)
      return true
    }).catch((er) => {
      GlobalUtility.generateResponseMessage(er, 'Login')
      GlobalUtility.failProgressBar()
      return false
    })
  },

  /**
   * @author get account
   */
  async set_account ({ commit }, params) {
    return await axios.get(`${USER_ACCOUNTS}/${params}`)
      .then((r) => {
        console.log('set_account', r.data)
        commit('set_account')
        return true
      }).catch((er) => {
        GlobalUtility.generateResponseMessage(er, 'Login')
        GlobalUtility.failProgressBar()
        return false
      })
  },

  create_account ({ commit }, params) {
    return axios.post(USER_ACCOUNTS, params).then((r) => {
      return true
    }).catch((er) => {
      if (!er.response) {
        GlobalUtility.generateResponseMessage(er, 'Login')
      }
      GlobalUtility.failProgressBar()
      return false
    })
  },

  update_account ({ commit }, params) {
    console.log('update_account:actions', params)
    return axios.put(`${USER_ACCOUNTS}/${params.id}`, params).then((r) => {
      console.log('update_account:', r.data)
      commit('update_account', r.data)
      return true
    }).catch((er) => {
      if (!er.response) {
        console.log('Cant establish service connection', er)
      }
      return false
    })
  },

  // TODO
  delete_account ({ commit }, params) {
    return axios.delete(`${USER_ACCOUNTS}/${params}`).then((r) => {
      console.log('delete_account:', r.data)
      commit('delete_account', r.data)
      return true
    }).catch((er) => {
      if (!er.response) {
        console.log('Cant establish service connection')
      }
      return false
    })
  },

  reset_state_account ({ commit }) {
    commit('reset_state_account')
  },

  reset_obj_user_types ({ commit }) {
    commit('reset_obj_user_types')
  },

  reset_obj_positions ({ commit }) {
    commit('reset_obj_positions')
  },

  reset_obj_account ({ commit }) {
    commit('reset_obj_account')
  },

  view_account ({ commit }, params) {
    commit('set_account', params)
  }
}

const getters = {
  accounts: state => state.accounts,
  account: state => state.account,
  newAccount: state => state.newAccount,
  objUserTypes: state => state.objUserTypes,
  objPositions: state => state.objPositions
}

export default {
  state,
  actions,
  mutations,
  getters
}
